//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axios from 'axios'
import PreEntryApi from '../assets/js/preentry'

export default {
  name: 'li_area_hu_select',
  model: {
    prop: 'caddress',
    event: 'change'
  },
  props: {
    caddress: {
      type: Object,
      default: () => ({ sheng: '', shi: '', qu: '' }) // 给默认值，避免空对象报错
    }
  },
  data () {
    return {
      areaJson: '../static/json/address.json',
      addressArray: [],
      cityArray: [],
      areaArray: [],
      select_address: {},
      // 核心：定义本地变量，深拷贝 Prop 值（避免引用类型关联）
      localCaddress: { ...this.caddress }
    }
  },
  watch: {
    // 监听父组件传入的 caddress 变化，同步到本地变量
    caddress: {
      deep: true, // 监听对象内部属性变化
      handler (newVal) {
        this.localCaddress = { ...newVal } // 深拷贝，避免引用关联
      }
    },
    // 原有的省变化监听，改为监听本地变量
    'localCaddress.sheng' (newVal) {
      if (!newVal) {
        this.cityArray = []
        this.areaArray = []
        return
      }
      for (let ad of this.addressArray) {
        if (ad.areaname === newVal) {
          this.cityArray = ad.subarea || []
          // 自动赋值区
          if (this.localCaddress.shi) {
            for (let area of this.cityArray) {
              if (area.areaname === this.localCaddress.shi) {
                this.areaArray = area.subarea || []
                return
              }
            }
          } else {
            this.areaArray = []
          }
          return
        }
      }
      this.cityArray = []
      this.areaArray = []
    }
  },
  created () {
    this.getAddressData()
  },
  methods: {
    getAddressData () {
      const that = this
      PreEntryApi.getCityInfoOfRedis(
        {},
        (response, meta) => {
          if (response.status === 200) {
            that.handleInfo(response)
          }
          if (response.status !== 200 || !response.data.data) {
            axios.get(that.areaJson).then(function (response) {
              if (response.status === 200) {
                that.handleInfo(response)
              }
            })
          }
        }
      )
    },
    handleInfo (response) {
      const that = this
      // 过滤掉中国台湾、中国香港、中国澳门
      console.log(response.data.data)
      that.addressArray = response.data.data.filter(item =>
        !['中国台湾', '中国香港', '中国澳门'].includes(item.areaname)
      )
      // 默认值赋值获取城市数组：改为操作本地变量
      if (that.localCaddress.sheng) {
        for (let ad of that.addressArray) {
          if (ad.areaname === that.localCaddress.sheng) {
            that.select_address.sheng_id = ad.id
            that.select_address.sheng_code = ad.areacode
            that.$emit('func', that.select_address)
            that.cityArray = ad.subarea
            // 默认赋值获取区域数组
            if (that.localCaddress.shi) {
              for (let area of that.cityArray) {
                if (area.areaname === that.localCaddress.shi) {
                  that.select_address.shi_id = area.id
                  that.select_address.shi_code = area.areacode
                  that.$emit('func', that.select_address)
                  that.areaArray = area.subarea
                  break
                }
              }
            }
          }
        }
      }
    },
    // 选择省份：改为操作本地变量，最后 emit 同步给父组件
    getCityData (val) {
      // 清空市、区：操作本地变量
      this.localCaddress.shi = ''
      this.localCaddress.qu = ''
      this.select_address.shi_id = 0
      this.select_address.qu_id = 0
      this.areaArray = []
      // 发送本地变量给父组件
      this.$emit('change', { ...this.localCaddress })
      for (let ad of this.addressArray) {
        if (ad.areaname === val) {
          this.select_address.sheng_id = ad.id
          this.select_address.sheng_code = ad.areacode
          this.cityArray = ad.subarea
          this.$emit('func', this.select_address)
          return
        }
      }
    },
    // 选择市区：改为操作本地变量
    getAreaData (val) {
      // 清空区：操作本地变量
      this.localCaddress.qu = ''
      this.select_address.qu_id = 0
      // 发送本地变量给父组件
      this.$emit('change', { ...this.localCaddress })
      for (let area of this.cityArray) {
        if (area.areaname === val) {
          this.select_address.shi_id = area.id
          this.areaArray = area.subarea
          this.$emit('checkResidenceType')
          this.$emit('func', this.select_address)
          return
        }
      }
    },
    // 选择区县：改为操作本地变量
    onAreaChanged (val) {
      // 发送本地变量给父组件
      this.$emit('change', { ...this.localCaddress })
      for (let area of this.areaArray) {
        if (area.areaname === val) {
          this.select_address.qu_id = area.id
          this.$emit('func', this.select_address)
          return
        }
      }
    },
    // 外部调用赋值：改为给本地变量赋值
    getCaddress (val, val2) {
      this.localCaddress = { ...val } // 深拷贝，避免引用关联
      this.select_address = val2
      this.getAddressData()
      // 同步给父组件
      this.$emit('change', { ...this.localCaddress })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/li_area_hu_select.vue